var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0526 5.26316H39.4737V0H35.5263V5.26316H14.4737V0H10.5263V5.26316H3.94737C1.7673 5.26316 0 7.03045 0 9.21053V46.0526C0 48.2327 1.7673 50 3.94737 50H46.0526C48.2327 50 50 48.2327 50 46.0526V9.21053C50 7.03045 48.2327 5.26316 46.0526 5.26316ZM5.26316 9.21046H10.5263V11.842H14.4737V9.21046H35.5263V11.842H39.4737V9.21046H44.7368C45.4635 9.21046 46.0526 9.79956 46.0526 10.5262V15.7894H3.94737V10.5262C3.94737 9.79956 4.53647 9.21046 5.26316 9.21046ZM46.0526 44.7367V19.7367H3.94737V44.7367C3.94737 45.4634 4.53647 46.0525 5.26316 46.0525H44.7368C45.4635 46.0525 46.0526 45.4634 46.0526 44.7367ZM25.5566 37.2184L31.579 41.4473L29.2868 34.5079L35.3224 30.1223H27.8618L25.5566 23.0263L23.25 30.1223H15.7895L21.8263 34.5079L19.5211 41.6039L25.5566 37.2184Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.5ca6c192451ff5b87e5069113fdc9aec.svg";
export { ForwardRef as ReactComponent };